<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.recordInformation}}</h3>
    <h5 class="modal-subtitle">
        <span [innerHTML]="recordTitle | safeHtml"></span>
    </h5>
</div>
<div class="modal-body">
    <div style="max-height:400px;overflow-y:auto;overflow-x:hidden">
        <div *ngFor='let field of Object.values(record)' [hidden]="!field.value" class="list-group-item">
            <h4 class="list-group-item-heading">{{field.label}}</h4>
            <div *ngIf="field.links">
                <ul class="link-list">
                    <li *ngFor="let link of field.links">
                        <a *ngIf="link.href.indexOf('file://')!=10" 
                            href="{{link.href.replace('////','//')}}" 
                            target="_blank" 
                            (click)="displayLinkMsg(link.href)"> 
                            {{link.name.replace('////','//')}} 
                        </a>
                    </li>
                </ul>
            </div>
            <div *ngIf="!field.links && searchableMetadataFields.includes(field.name)">
				<a *ngIf="field.isValidCollection" 
				   class="pointMe" 
				   (click)="resultFieldSearch(field.name, field.cleanedValue)" 
				   [title]="field.cleanedValue">
				  {{ field.cleanedValue }}
				</a> 
                <p *ngIf="!field.isValidCollection"
                    class='dd-text-collapse'
                    ddTextCollapse
                    [ddTextCollapseMaxLength]="field.maxLength" 
                    [ddTextCollapseText]="field.cleanedValue">
                </p>
            </div>                                  
            <p *ngIf="!field.links && !searchableMetadataFields.includes(field.name)"
               class='dd-text-collapse'
               ddTextCollapse
               [ddTextCollapseMaxLength]="field.maxLength" 
               [ddTextCollapseText]="field.cleanedValue">
            </p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
